// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.fak_title[data-v-ece6063e] {\n  width: 65%;\n  float: left;\n  text-align: center;\n  padding-left: 410px;\n  padding-top: 10px;\n  font-size: 30px;\n  font-weight: bold;\n}\n.fak_title_sub[data-v-ece6063e] {\n  width: 35%;\n  float: right;\n  padding-left: 80px;\n  font-size: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
